import React from 'react';
import { Star } from 'lucide-react';
import { getLogoUrl } from '../config/api';

const BracketMatch = ({ game, language }) => {
  const completed = game.status === 'completed';
  const homeWin = completed && game.home_score > game.away_score;
  const awayWin = completed && game.away_score > game.home_score;
  const homeTBD = !game.home_team_id || game.home_team_id === 'TBD';
  const awayTBD = !game.away_team_id || game.away_team_id === 'TBD';

  return (
    <div className="bg-white rounded-xl border-2 border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition w-full" data-testid={`bracket-${game.id}`}>
      <div className={`flex items-center justify-between px-3 py-2.5 border-b ${homeWin ? 'bg-green-50 border-green-200' : 'border-slate-100'}`}>
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {!homeTBD ? (
            <img src={getLogoUrl(game.home_team_id)} alt="" className="w-6 h-6 rounded-full object-cover flex-shrink-0" onError={e => { e.target.style.display='none'; }} />
          ) : (
            <Star className="text-[#F97316] flex-shrink-0" size={16} />
          )}
          <span className={`text-sm truncate ${homeWin ? 'font-bold text-green-700' : 'font-medium text-slate-700'}`}>{game.home_team_name}</span>
        </div>
        <span className={`text-sm font-bold px-2 min-w-[24px] text-center ${homeWin ? 'text-green-700' : 'text-slate-500'}`}>
          {completed ? game.home_score : '-'}
        </span>
      </div>
      <div className={`flex items-center justify-between px-3 py-2.5 ${awayWin ? 'bg-green-50' : ''}`}>
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {!awayTBD ? (
            <img src={getLogoUrl(game.away_team_id)} alt="" className="w-6 h-6 rounded-full object-cover flex-shrink-0" onError={e => { e.target.style.display='none'; }} />
          ) : (
            <Star className="text-[#F97316] flex-shrink-0" size={16} />
          )}
          <span className={`text-sm truncate ${awayWin ? 'font-bold text-green-700' : 'font-medium text-slate-700'}`}>{game.away_team_name}</span>
        </div>
        <span className={`text-sm font-bold px-2 min-w-[24px] text-center ${awayWin ? 'text-green-700' : 'text-slate-500'}`}>
          {completed ? game.away_score : '-'}
        </span>
      </div>
    </div>
  );
};

export default BracketMatch;
